// PROTOTYPE ONLY (087 Super Match, ticket 10). See bestMatchPrototype.data.ts.
import { motion } from 'framer-motion';
import { scenarios } from './bestMatchPrototype.data';
import type { BestMatchPrototypeControls } from './useBestMatchPrototype';

export const BestMatchPrototypeSwitcher = ({ controls }: { controls: BestMatchPrototypeControls }) => (
  <div className="fixed bottom-6 left-1/2 z-[60] flex -translate-x-1/2 flex-wrap items-center justify-center gap-3 rounded-full bg-gray-950/95 px-3 py-2 text-white shadow-xl backdrop-blur">
    <span className="text-sm">Best Match — approved treatment</span>
    <span className="mx-1 h-5 w-px bg-white/20" aria-hidden />
    <div className="flex items-center gap-1">
      {scenarios.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => controls.setScenario(item.key)}
          className={`relative rounded-full px-2.5 py-1 text-xs transition-colors ${
            controls.scenario === item.key ? 'text-gray-950' : 'text-white/70 hover:text-white'
          }`}
        >
          {controls.scenario === item.key && (
            <motion.span layoutId="best-match-proto-scenario" className="absolute inset-0 rounded-full bg-white" />
          )}
          <span className="relative">{item.label}</span>
        </button>
      ))}
    </div>
  </div>
);
